import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import '../styles/QA.css';

const QA = () => {
    useEffect(() => {
        // Add class to body when component mounts
        document.body.classList.add('qa-page-active');

        // Remove class when component unmounts
        return () => {
            document.body.classList.remove('qa-page-active');
        };
    }, []);

    return (
        <div className="qa-page">
            <div className="qa-content">
                <div className="container">
                    <div className="page-content">
                        <div className="hero-image">
                            <div className="moon">
                                <svg width="400" height="240" viewBox="0 0 400 240" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle className="full-moon" cx="132.75" cy="119.75" r="66.75" fill="white" />
                                    <path className="half-moon" opacity="0.2" d="M199.5 186.5C208.266 186.5 216.946 184.773 225.044 181.419C233.143 178.064 240.501 173.148 246.699 166.949C252.898 160.751 257.814 153.393 261.169 145.294C264.523 137.196 266.25 128.516 266.25 119.75C266.25 110.984 264.523 102.304 261.169 94.2059C257.814 86.1074 252.898 78.7489 246.699 72.5506C240.501 66.3523 233.143 61.4355 225.044 58.081C216.946 54.7265 208.266 53 199.5 53L199.5 119.75L199.5 186.5Z" fill="white" />
                                    <path className="half-moon" opacity="0.2" d="M266.25 186.5C275.016 186.5 283.696 184.773 291.794 181.419C299.893 178.064 307.251 173.148 313.449 166.949C319.648 160.751 324.564 153.393 327.919 145.294C331.273 137.196 333 128.516 333 119.75C333 110.984 331.273 102.304 327.919 94.2059C324.564 86.1074 319.648 78.7489 313.449 72.5506C307.251 66.3523 299.893 61.4355 291.794 58.081C283.696 54.7265 275.016 53 266.25 53L266.25 119.75L266.25 186.5Z" fill="white" />
                                </svg>
                            </div>
                            <img src="/images/qa.jpg" alt="Readme" />
                        </div>
                    </div>
                    <div className="read-me-container">
                        <div className="read-me-content">
                            <h1>Q&A</h1>
                        </div>
                        <div className="read-me-content">
                            <div className="qa-item">
                                <h4>
                                    Does Fiktion train on my work?
                                </h4>
                                <p>
                                    No, Fiktion does not train on your work. It doesn't scrape it. It doesn't learn from it. And it doesn't feed it to any large language model.
                                    Your writing is yours. Full stop.
                                </p>
                            </div>
                            <div className="qa-item">
                                <h4>
                                    Can I switch from my existing screenwriting software?
                                </h4>
                                <p>
                                    Yes, you can switch from your existing screenwriting software. Fiktion offers a seamless transition from your current tool. Just export your screenplay as an XML file (FDX file if you use Final Draft), and import it into Fiktion.
                                </p>
                            </div>
                            <div className="qa-item">
                                <h4>
                                    Is Fiktion free?
                                </h4>
                                <p>
                                    Fiktion is free while in beta. Once it's fully launched, there will be a subscription model, with a continued- yet limited free tier for those who want to try it out.
                                </p>
                            </div>
                            <div className="qa-item">
                                <h4>
                                    Will Fiktion be available on macOS?
                                </h4>
                                <p>
                                    Fiktion is a web-based application that runs in your browser, available for download. Check the <a href="/download">"Download"</a> page for more information.
                                </p>
                            </div>
                            <div className="qa-item">
                                <h4>
                                    Will Fiktion be available on mobile?
                                </h4>
                                <p>
                                    Eventually Fiktion will be available on mobile, yes. Right now the focus is to create the best possible experience for desktop.
                                </p>
                            </div>
                            <div className="qa-item">
                                <h4>
                                    I have a question that's not on this list. How do I get in touch?
                                </h4>
                                <p>
                                    Please contact me at <a href="mailto:help@fiktion.app">help@fiktion.app</a>.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="divider"></div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default QA;
